module.exports = __webpack_public_path__ + "static/img/home_product_05_zh.5b31bf2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home_product_05_zh.png
// module id = /1nZ
// module chunks = 34